import React from 'react';
import LayoutDashboard from '../../layout';
import { Switch, Route } from 'react-router-dom';
import { useRouter } from 'hooks/use-router';
import UserActivityLogList from './pages/user-activity-log-list/user-activity-log-list';
import UserActivityLogDetail from './pages/user-activity-log-detail/user-activity-log-detail';

type TUserActivityLog = {};

const UserActivityLog: React.FC<TUserActivityLog> = () => {
    const { match } = useRouter();

    return (
        <>
            <LayoutDashboard>
                <Switch>
                    <Route exact path={match.path}>
                        <UserActivityLogList />
                    </Route>
                    <Route path={`${match.path}/:id`}>
                        <UserActivityLogDetail />
                    </Route>
                </Switch>
            </LayoutDashboard>
        </>
    );
};

export default UserActivityLog;
